import React from 'react'
import TableTitle from './TableTitle'
import OrganizationalTable from './OrganizationalTable'
import FurnitureAndEquipmentTable from './FurnitureAndEquipmentTable'
import BiomechanicsTable from './BiomechanicsTable'
import AmbientalTable from './AmbientalTable'
import PsychosocialCognitiveTable from './PsychosocialCognitiveTable'
import View from '../../../../../../components/pdf/View'
import Text from '../../../../../../components/pdf/Text'
import { Table, TableCol, TableRow } from '../../../../../../components/pdf/Table'

const TableWrapper = ({ placeData, data }) => {
  return (
    <View>
      <TableTitle placeData={placeData} />
      {data.map((item, index) => {
        return (
          <View pageBreakAfter key={index}>
            <Table width={'100%'} useFontBaseColor>
              <TableRow bgColor={'#727272'} useFontBaseColor>
                <TableCol colspan="5" useFontBaseColor>
                  <Text bold align={'center'}>
                    Tabela de Nível de Priorização de Riscos x Sugestões de melhorias
                  </Text>
                </TableCol>
              </TableRow>
            </Table>
            {!!item?.organizacaoTrabalho?.length && <OrganizationalTable categorizedReplies={item} />}
            {!!item?.mobiliariosEquipamentos?.length && <FurnitureAndEquipmentTable categorizedReplies={item} />}
            {!!item?.biomecanico?.length && <BiomechanicsTable categorizedReplies={item} />}
            {!!item?.ambientais?.length && <AmbientalTable categorizedReplies={item} />}
            {!!item?.psicossociaisCognitivos?.length && <PsychosocialCognitiveTable categorizedReplies={item} />}
          </View>
        )
      })}
    </View>
  )
}

export default TableWrapper
